<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";

/**
 * Starter component
 */
export default {
    components: { Layout, PageHeader },
    data() {
        return {
            title: "Crear Colegios",
            items: [
                {
                text: "Utility",
                href: "/"
                },
                {
                text: "Starter Page",
                active: true
                }
            ],
            colegios:[],
            totalRows: 1,
            currentPage: 1,
            perPage: 10,
            pageOptions: [10, 25, 50, 100],
            filter: null,
            filterOn: [],
            sortBy: "age",
            sortDesc: false,
            fields: [
                { key: "nombre",label:'Nombre', sortable: true },
                { key: "region_id",label:'Región', sortable: true },
                { key: "comuna_id",label:'Comuna', sortable: true },
                { key: "acciones",label:'Acciones', sortable: true },
            ],
            colegio:{
                nombre:'',
                region_id:'',
                comuna_id:''
            },
            regiones:[],
            comunas:[],
        };
    },
    computed: {
    /**
     * Total no. of records
     */
        rows() {
            return this.colegios.length;
        }
    },
    mounted() {
    // Set the initial number of items
        this.totalRows = this.items.length;
    },
    created() {
        this.actualizar();
    },
    methods: {
    /**
     * Search the table data with search input
     */
        onFiltered(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },
        actualizar(){
            axios.get('/api/get_colegios').then(res=>{
                this.colegios = res.data.colegios;
                this.regiones = res.data.regiones;
                this.comunas = res.data.comunas;
                this.user.rol_id==1?console.log(this.colegios):''
                this.colegio.nombre=''//reinicia variables despues de crear colegio
                this.colegio.region_id=''
                this.colegio.comuna_id=''
            });
            //console.log('carga colegios')
        },
        crear_colegio(){
            let payload={
                    nombre:this.colegio.nombre,
                    region_id:this.colegio.region_id,
                    comuna_id:this.colegio.comuna_id
                }
            axios.post('/api/crear_colegio', payload).then(res=>{
                if(res.data.estado){
                    //this.$toasted.success(res.data.mensaje);
                    //console.log('creado')
                    this.actualizar();
                    this.$bvModal.hide('modal_colegio')
                    
                }else{
                    //this.$toasted.error(res.data.mensaje);
                }
            });
        },
        editar_colegio_modal(item){
            this.colegio.id=item.id
            this.colegio.nombre=item.nombre
            this.colegio.region_id=item.region_id
            this.colegio.comuna_id=item.comuna_id
            this.$bvModal.show('modal_colegio_editar')
        },
        editar_colegio(){
            let payload={
                    id:this.colegio.id,
                    nombre:this.colegio.nombre,
                    region_id:this.colegio.region_id,
                    comuna_id:this.colegio.comuna_id
                }
            axios.post('/api/editar_colegio', payload).then(res=>{
                if(res.data.estado){
                    //this.$toasted.success(res.data.mensaje);
                    console.log('Editado')
                    this.actualizar();
                    this.$bvModal.hide('modal_colegio_editar')
                    
                }else{
                    //this.$toasted.error(res.data.mensaje);
                }
            });
        }
    }
};
</script>
<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-12">
                                <b-button class="float-right" variant="primary" v-b-modal.modal_colegio>Nuevo Colegio</b-button>
                                <!-- <b-button class="float-right" variant="primary" @click="actualizar()">Actualizar</b-button> -->
                    <!-- Modal crear colegio -->
                                <b-modal id="modal_colegio" title="Crear Nuevo Colegio" cancel-title="Cancelar" ok-title="Crear" @ok="crear_colegio">
                                    <b-form-group id="nombre" label-cols-sm="2" label-cols-lg="2" label="Nombre" label-for="text">
                                        <b-form-input for="text" v-model="colegio.nombre"></b-form-input>
                                    </b-form-group>
                                    <b-form-group id="example text" label-cols-sm="2" label-cols-lg="2" label="Región" label-for="text">
                                        <div class="col-md-10">
                                            <select class="custom-select" v-model="colegio.region_id" @change="colegio.comuna_id=''">
                                                <option value="" selected>Seleccione Región</option>
                                                <option  v-for="region in regiones" :key="region.id" :value="region.id">{{region.nombre}}</option>
                                            </select>
                                        </div>
                                    </b-form-group>
                                    <b-form-group id="example text" label-cols-sm="2" label-cols-lg="2" label="Comuna" label-for="text">
                                        <div class="col-md-10">
                                            <select class="custom-select" v-model="colegio.comuna_id" :disabled="colegio.region_id==''">
                                                <option value="" selected>Seleccione Comuna</option>
                                                <option  v-for="comuna in comunas.filter(item => item.region_id == colegio.region_id)" :key="comuna.id" :value="comuna.id">{{comuna.nombre}}</option>
                                            </select>
                                        </div>
                                    </b-form-group>
                                    <!-- <b-button class="float-right" variant="success" @click="crear_colegio" :disabled="colegio.nombre==''" >Crear</b-button> -->
                                </b-modal>
                    <!-- Modal editar colegio -->
                                <b-modal id="modal_colegio_editar" title="Editar Colegio" cancel-title="Cancelar" ok-title="Editar" @ok="editar_colegio">
                                    <b-form-group id="nombre" label-cols-sm="2" label-cols-lg="2" label="Nombre" label-for="text">
                                        <b-form-input for="text" v-model="colegio.nombre"></b-form-input>
                                    </b-form-group>
                                    <b-form-group id="example text" label-cols-sm="2" label-cols-lg="2" label="Región" label-for="text">
                                        <div class="col-md-10">
                                            <select class="custom-select" v-model="colegio.region_id" @change="colegio.comuna_id=''">
                                                <option value="" selected>Seleccione Región</option>
                                                <option  v-for="region in regiones" :key="region.id" :value="region.id">{{region.nombre}}</option>
                                            </select>
                                        </div>
                                    </b-form-group>
                                    <b-form-group id="example text" label-cols-sm="2" label-cols-lg="2" label="Comuna" label-for="text">
                                        <div class="col-md-10">
                                            <select class="custom-select" v-model="colegio.comuna_id" :disabled="colegio.region_id==''" >
                                                <option value="" selected>Seleccione Comuna</option>
                                                <option  v-for="comuna in comunas.filter(item => item.region_id == colegio.region_id)" :key="comuna.id" :value="comuna.id">{{comuna.nombre}}</option>
                                            </select>
                                        </div>
                                    </b-form-group>
                                    <!-- <b-button class="float-right" variant="success" @click="editar_colegio" :disabled="colegio.nombre==''" >Editar</b-button> -->
                                </b-modal>
                            </div>
                        </div>
                        <!-- <h4 class="card-title">Data Table</h4> -->
                        <div class="row mt-4">
                            <div class="col-sm-12 col-md-6">
                                <div id="tickets-table_length" class="dataTables_length">
                                    <label class="d-inline-flex align-items-center">
                                        Mostrar&nbsp;
                                        <b-form-select v-model="perPage" size="sm" :options="pageOptions"></b-form-select>&nbsp;colegios
                                    </label>
                                </div>
                            </div>
                            <!-- Search -->
                            <div class="col-sm-12 col-md-6">
                                <div id="tickets-table_filter" class="dataTables_filter text-md-right">
                                    <label class="d-inline-flex align-items-center">
                                        Buscar:
                                        <b-form-input
                                        v-model="filter"
                                        type="search"
                                        placeholder="Buscar..."
                                        class="form-control form-control-sm ml-2"
                                        ></b-form-input>
                                    </label>
                                </div>
                            </div>
                            <!-- End search -->
                        </div>
                        <!-- Table -->
                        <div class="table-responsive mb-0">
                            <b-table :items="colegios" :fields="fields" responsive="sm" :per-page="perPage" :current-page="currentPage" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :filter="filter" :filter-included-fields="filterOn" @filtered="onFiltered" >
                                <template v-slot:cell(n)="data">
                                    <p>{{ data.index+1 }}</p>
                                </template>
                                <template v-slot:cell(acciones)="data">
                                    <b-button size="sm" variant="primary" @click="editar_colegio_modal(data.item)">Editar</b-button>
                                </template>
                                <template v-slot:cell(region_id)="data">
                                    <p>{{ data.item.region_nombre }}</p>
                                </template>
                                <template v-slot:cell(comuna_id)="data">
                                    <p>{{ data.item.comuna_nombre }}</p>
                                </template>
                            </b-table>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="dataTables_paginate paging_simple_numbers float-right">
                                    <ul class="pagination pagination-rounded mb-0">
                                        <!-- pagination -->
                                        <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"></b-pagination>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>